export default __webpack_public_path__ + "13364726ecf97dc4ab9ed1f7ef03d30b.png";